// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".CenteredDiv-cls1___904eb07ac9280523f79{/*!*/}.CenteredDiv-cls2___77d9ebe437b959700a7{text-align:center;margin:auto}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "CenteredDiv-cls1___904eb07ac9280523f79",
	"cls2": "CenteredDiv-cls2___77d9ebe437b959700a7 CenteredDiv-cls1___904eb07ac9280523f79"
};
export default ___CSS_LOADER_EXPORT___;
